export default function ShieldIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 2L4 8V16C4 23.732 16 30 16 30C16 30 28 23.732 28 16V8L16 2Z" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
